import { AuthConfig } from 'angular-oauth2-oidc';

export function buildAuthConfig(issuer: string, clientId: string): AuthConfig {
  return {
    issuer,
    redirectUri: window.location.origin + '/auth/callback',
    clientId,
    responseType: 'code',
    scope: 'openid profile email',
    showDebugInformation: true,
    requireHttps: false,
    loginUrl: `${issuer}/oauth/v2/authorize`,
  };
}
